
import { Component, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { debounceTime, lastValueFrom } from 'rxjs';
import { LoginPopupComponent } from 'src/app/components/login-popup/login-popup.component';
import { MBlogFilterRequest, MCommonListModalRequest, SharedPrefrences } from 'src/app/utils/utils.service';
import { MAddUpdateCartModule, MAddUpdateCartModuleResponse } from '../product-detail-updated/product-detail-updated.module';
import { WsShopallService } from 'src/app/ws/wsShopAll/ws-shopall.service';
import { CommonBehaviorChangeService } from 'src/app/utils/common-behaviour-service';
import { WsBlogService } from 'src/app/ws/wsBlog/ws-blog.service';
import { MCategoryResponseModal, MblogResponse } from '../blog/blog.module';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
@Component({
  selector: 'app-individual-blog-updated',
  templateUrl: './individual-blog-updated.component.html',
  styleUrls: ['./individual-blog-updated.component.scss']
})
export class IndividualBlogUpdatedComponent {
  mBlogModalRequest: MCommonListModalRequest = new MCommonListModalRequest()
  mblogResponse: any = [];
  mCategoryResponseModal: MCategoryResponseModal = new MCategoryResponseModal()
  private storageKey = 'searchBlogHistory';
  jsonData: any = [];
  share: any;
  baseUrl: any = window.location.origin;
  shareUrl: any;
  allTrendingBlogsCategoryWise: any = [];
  blogSlider: OwlOptions = {
    loop: true,
    margin: 10,
    autoplay: true,
    nav: true,
    dots: false,
    autoplayTimeout: 3000,
    smartSpeed: 2500,
    navText: [
      '<span><img src="assets/images/left-blog-arrow.svg" alt="icon" /></span>',
      '<span class="arrow-rotate"><img src="assets/images/right-blog-arrow.svg" alt="icon" /></span>'
    ],
    responsive: {
      0: {
        items: 1.5,
      },
      450: {
        items: 3,
      },
      576: {
        items: 2,
      },
      768: {
        items: 2,
        margin: 10
      },
      992: {
        items: 3,
        margin: 50
      }
    }
  }
  blogDetail: any = null;
  mAddUpdateCartModule: MAddUpdateCartModule = new MAddUpdateCartModule();
  mAddUpdateCartModuleResponse: MAddUpdateCartModuleResponse = new MAddUpdateCartModuleResponse()
  mCommonListModalRequest: MCommonListModalRequest = new MCommonListModalRequest();
  mBlogCategoryListRequest: MBlogFilterRequest = new MBlogFilterRequest();
  trendingBlogs: any = []
  newtrendingBlogs: any = []
  bannerImage: any;
  categoryId: any;
  blogId: any;
  blogSearchForm: FormGroup;
  show: boolean = false;
  historyShow: any;
  searchHistory: any;
  arrSearchHistory: any = [];
  shareURL: any;
  currentUrl: any = decodeURI(window.location.href);
  subCategoryData: any;
  getCategoryArray: any;
  encodeUrl: any;
  facebookUrl: any = encodeURIComponent(window.location.href)

  constructor(private formBuilder: FormBuilder, private wsblogservice: WsBlogService,
    private router: Router, private activatedRoute: ActivatedRoute,
    private modalService: NgbModal, private wsShopAllService: WsShopallService,
    private _commonBehaviorChangeService: CommonBehaviorChangeService,
    private toast: ToastrService) {
    this.activatedRoute.params.subscribe(async (data) => {
      this.categoryId = data['categoryId']
      this.blogId = data['blogId']
      this.getBlogList(this.categoryId, this.blogId)
      this.getTrendingBlogList();
      this.getBlogList(53)
    })

    this.blogSearchForm = this.formBuilder.group({
      search: new FormControl('')
    })

    this.blogSearchForm.get('search')?.valueChanges.pipe(
      debounceTime(300)
    ).subscribe(() => {
      this.getBlogListSearch();
    });
    this._commonBehaviorChangeService.currentrCartList.subscribe((cartList: any) => {
      this.mAddUpdateCartModuleResponse.data = cartList.data;
    })
  }

  async addToCartCommon(product: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    this.mAddUpdateCartModule.iswishlistitem = false;
    this.mAddUpdateCartModule.product_id = product.id;
    const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === product.id })
    if (cart > -1) {
      this.mAddUpdateCartModule.qty = this.mAddUpdateCartModuleResponse.data[cart].qty + 1;
      this.mAddUpdateCartModule.id = this.mAddUpdateCartModuleResponse.data[cart].id;
    } else {
      this.mAddUpdateCartModule.qty = 1;
    }
    const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
    await lastValueFrom(addRemoveProductFromCart).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddUpdateCartModule = new MAddUpdateCartModule();
        this._commonBehaviorChangeService.addCart(true);
      } else {
        console.log("something went wrong")
      }
    })
  }

  async addtoCart(product: any) {
    if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
      this.addToCartCommon(product)
    } else {
      const modalRef = this.modalService.open(LoginPopupComponent);
      modalRef.componentInstance.type = 1;
      modalRef.componentInstance.emitService.subscribe((emmitedValue: any) => {
        if (emmitedValue) {
          this.addToCartCommon(product)
        }
      })
    }
  }

  async getBlogList(catId: any, blogId?: any) {
    if (blogId) {
      this.mBlogCategoryListRequest.take = 1000;
    } else {
      this.mBlogCategoryListRequest.take = 4;
    }
    this.mBlogCategoryListRequest.catagoryid = catId;

    const getEditorsPickList = this.wsblogservice.getBlogListByCategoryFilter(this.mBlogCategoryListRequest);
    await lastValueFrom(getEditorsPickList).then(response => {
      if (response && response.statusCode == 200) {
        if (blogId) {
          this.blogDetail = response['data'].filter((blog: any) => blog.id == blogId)[0];
          this.getCategoryList(this.blogDetail?.category_id);
          if (this.blogDetail.subcatagory_id != null) {
            this.getSubCategoryList(this.blogDetail.category.id, this.blogDetail.subcatagory_id)
          }
          this.bannerImage = this.getBlogThumbnail(this.blogDetail.imageList, 'blog_banner_image')
          if (this.blogDetail?.ingredients && this.blogDetail.ingredients.length > 0) {

            this.jsonData = JSON.parse(this.blogDetail.ingredients).filter((item: any) => {
              // Check if the item is not an empty string
              if (item !== "") {
                // Return true for non-object items that are not empty strings
                return true;
              }
              // Return false for empty strings
              return false;
            });
          }
        } else {
          this.trendingBlogs = response.data;
        }
      }
    })
  }

  async getSubCategoryList(categoryId: any, subCategoryId: any) {
    this.mBlogModalRequest.skip = 0;
    this.mBlogModalRequest.take = 1000;
    this.mBlogModalRequest.search = '';
    this.mBlogModalRequest.categoryIds = "" + categoryId;
    const getSubCategoryList = this.wsShopAllService.getAllSubCategory(this.mBlogModalRequest);
    await lastValueFrom(getSubCategoryList).then(response => {
      if (response && response.statusCode == 200) {
        let subCategoryData = response.data;
        if (subCategoryData && subCategoryData.length > 0 && subCategoryId != null) {
          this.subCategoryData = subCategoryData.filter((item: any) => item.id == subCategoryId)
        }
      }
    })
  }

  async getTrendingBlogList() {
    this.newtrendingBlogs = [];
    const newtrendingBlogs = this.wsblogservice.getBlogCataoryWiseWithAllFilter(true);
    await lastValueFrom(newtrendingBlogs).then(response => {
      if (response && response.statusCode == 200 && response.data) {
        this.allTrendingBlogsCategoryWise = response.data;
        response.data.forEach((blog: any) => {
          if (this.newtrendingBlogs.length < 1) {
            this.newtrendingBlogs = blog.blogs;
          } else {
            this.newtrendingBlogs = [...this.newtrendingBlogs, ...blog.blogs];
          }
        })
      }
    })
  }


  getnewTrendingBlogThumbnail(imageList: any) {
    if (imageList.length < 1) {
      return 'assets/images/noblogimage.jpg'
    }
    var thumbnail = imageList.filter((img: any) => img.type == 'blog_thumbnail_image')
    if (thumbnail.length > 0) {
      return thumbnail[0].path;
    }
    else {
      return 'assets/images/noblogimage.jpg'
    }
  }

  showProduct(product: any) {
    var productName = product.name.split(' ').join('_').replace(',', '')
    this.router.navigate(["/product-detail-updated/" + product.id + '/' + productName.replace(/[&\/\#,+()$~%.'":*?<>{}]/g, '_')])
  }

  async openBlogDetail(val: any) {
    this.searchHistory = this.getSearchHistory();
    let newSearch = this.searchHistory.filter((item: any) => item.id == val.id)
    if (newSearch == null || newSearch.length == 0) {
      this.searchHistory.unshift(val);
      if (val.title.length > 0) {
        localStorage.setItem(this.storageKey, JSON.stringify(this.searchHistory));
      }
    }
    else {
      this.searchHistory = this.searchHistory.filter((item: any) => item.id != val.id);
      this.searchHistory.unshift(val);
      if (val.title.length > 0) {
        localStorage.setItem(this.storageKey, JSON.stringify(this.searchHistory));
      }
    }

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(["/individual-blog-updated/" + val.title.split(' ').join('_') + '/' + val.category_id + '/' + val.id])
  }

  openBlogViaCategory() {
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['blog-list/' + this.blogDetail?.category?.id])
  }

  openBlogViaSubCategory() {
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['blog-list/' + this.blogDetail?.category?.id + '/' + this.blogDetail?.subcatagory_id])
  }

  getBlogThumbnail(imageList: any, type: any) {
    if (imageList && imageList.length < 1) {
      return ''
    }
    var thumbnail = imageList.filter((img: any) => img.type == type)
    if (thumbnail.length > 0) {
      return thumbnail[0].path;
    }
    else {
      return ''
    }
  }

  buyNow(product: any) {
    const productDetail = {
      qty: 1,
      productId: product.id
    }
    localStorage.setItem("buynow", JSON.stringify(productDetail))
    const userAgent = window.navigator.userAgent.toLowerCase();
    var mobile = /iphone|ipad|ipod|android|blackberry|iemobile|opera mini/i.test(userAgent)
    if (mobile) {
      this.router.navigate(["/checkout-new-mob/buynow/" + product.id])
    } else {
      this.router.navigate(["/checkout-new/buynow/" + product.id])
    }
  }

  showButton = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.pageYOffset > 200) {
      this.showButton = true;
    } else {
      this.showButton = false;
    }
  }

  gotToBlog() {
    this.router.navigate(["/blog"])
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  clickSearch() {
    if (this.blogSearchForm.controls['search'].value == '' || this.blogSearchForm.controls['search'].value == null) {
      this.show = false;
      this.historyShow = !this.historyShow;
      this.getSearchHistory();
    }
    else {
      this.historyShow = false;
    }
  }

  getSearchHistory() {
    this.searchHistory = localStorage.getItem(this.storageKey);
    if (this.searchHistory != 'undefined' && this.searchHistory != null) {
      this.arrSearchHistory = JSON.parse(this.searchHistory)
    }
    return this.arrSearchHistory;
  }

  ngOnInit() {
    this.getCategoryList()
    document.body.addEventListener('click', this.toggleShareBox.bind(this));
  }

  /**
   * Hide Share Box on outside click
   * @param event 
   */
  toggleShareBox(event: Event): void {
    const isInsideBlogIcon = (event.target as HTMLElement).closest('.blog-icon');
    const isSearchBlog = ((event.target as HTMLElement).closest('.blog-search-bar-new') || (event.target as HTMLElement).closest('.blog-filter-panel'));
    if (!isInsideBlogIcon) {
      this.share = null; // Hides the share box when clicked outside
    }
    if (!isSearchBlog) {
      this.show = false;
      this.historyShow = false;
    }
  }

  ngOnDestroy() {
    document.body.removeEventListener('click', this.toggleShareBox.bind(this));
  }

  async openBlogList(categoryId: any) {
    this.router.navigate(["/blog-list/" + categoryId])
  }


  /**
 * to get category list
 */
  async getCategoryList(id?: any) {
    const categoryListData = this.wsblogservice.getCategoryByType(2);
    await lastValueFrom(categoryListData).then(response => {
      if (response && response.statusCode == 200) {
        this.mCategoryResponseModal.data = response.data;
        if (id) {
          this.getCategoryArray = response.data.filter((item: any) => {
            return item.id == id;
          })

        }
      } else {
      }
    })
  }

  async getBlogListSearch() {
    this.mBlogModalRequest.skip = 0;
    this.mBlogModalRequest.take = 1000;
    this.mBlogModalRequest.search = this.blogSearchForm.controls['search'].value;
    if (this.blogSearchForm.controls['search'].value.length > 0) {
      this.show = true;
      this.historyShow = false;
      const getBlogs = this.wsblogservice.getBlogList(this.mBlogModalRequest);
      await lastValueFrom(getBlogs).then(response => {
        if (response && response.statusCode == 200) {
          this.mblogResponse.data = response.data;
          this.mblogResponse.data = this.mblogResponse.data.filter((item: any) => {
            if (item?.is_active == false) {
              return false;
            }
            return true;
          })
        }
      })
    }
    else {
      this.show = false;
      this.mblogResponse.data = [];
    }
  }

  async openBlogDetailSearch(val: any) {
    this.searchHistory = this.getSearchHistory();
    let newSearch = this.searchHistory.filter((item: any) => item.id == val.id)
    if (newSearch == null || newSearch.length == 0) {
      this.searchHistory.unshift(val);
      if (val.title.length > 0) {
        localStorage.setItem(this.storageKey, JSON.stringify(this.searchHistory));
      }
    }
    else {
      this.searchHistory = this.searchHistory.filter((item: any) => item.id != val.id);
      this.searchHistory.unshift(val);
      if (val.title.length > 0) {
        localStorage.setItem(this.storageKey, JSON.stringify(this.searchHistory));
      }
    }

    this.router.navigate(["/individual-blog-updated/" + val.title.split(' ').join('_') + '/' + val.category_id + '/' + val.id])
  }

  async showAllTrending() {
    this.router.navigate(["/blog-list-two"])
  }

  showShare(hide?: any) {
    if (hide == 'hide') {
      this.share = null;
    }
    else {
      if (this.share == hide.id) {
        this.share = null;
      }
      else {
        this.share = hide.id;
        this.shareUrl = decodeURI(this.baseUrl + "/individual-blog-updated/" + hide.title.split(' ').join('_') + '/' + hide.category_id + '/' + hide.id);
        this.encodeUrl = encodeURIComponent(this.baseUrl + "/individual-blog-updated/" + hide.title.split(' ').join('_') + '/' + hide.category_id + '/' + hide.id);
      }
    }
  }


  clickToCopy(copy: any) {

    const blogData = this.baseUrl + "/individual-blog-updated/" + copy.title.split(' ').join('_') + '/' + copy.category_id + '/' + copy.id;
    const textarea = document.createElement('textarea');
    textarea.value = blogData;
    document.body.appendChild(textarea);

    // Select the text in the textarea
    textarea.select();
    document.execCommand('copy');

    // Clean up - remove the textarea
    document.body.removeChild(textarea);
    this._commonBehaviorChangeService.getToast('Blog Link Copied');

    this.showShare('hide');
  }

}
